import { Link, useParams } from 'react-router-dom'

// サンプルデータ
const reservationData = {
  'res-001': {
    id: 'res-001',
    patientName: 'KuKn',
    researchId: 'R01166',
    patientId: '39-011',
    scheduledDate: '2025-11-28',
    scheduledTime: '14:00',
    transplantCount: 3,
    timeSlot: '14:00〜14:30',
    donorDesignation: null,
    notes: '本日で3回コース終了',
    orderStatus: '完了',
    orderDate: '2025-10-03 13:46',
    fluidShippingDate: '2025-10-27',
    fluidArrival: 'あり',
    trackingNumber: '4411-5345-4151',
    primaryDoctor: 'Baseクリニック赤坂',
    transplantDoctor: 'Baseクリニック赤坂',
    createdBy: '事務局（水谷恭子）',
    bacteriaType: 'C2',
    fluidType: 'カプチューシャ',
    volume: 130,
    concentration: 13.2,
  },
  'res-002': {
    id: 'res-002',
    patientName: 'ItuHrs',
    researchId: 'R01598',
    patientId: '13-079',
    scheduledDate: '2025-11-27',
    scheduledTime: '16:30',
    transplantCount: 6,
    timeSlot: '16:30〜17:00',
    donorDesignation: null,
    notes: null,
    orderStatus: '処理中',
    orderDate: '2025-11-01 10:00',
    fluidShippingDate: null,
    fluidArrival: null,
    trackingNumber: null,
    primaryDoctor: '二子玉川メディカルクリニック',
    transplantDoctor: '二子玉川メディカルクリニック',
    createdBy: '事務局（水谷恭子）',
    bacteriaType: 'B1',
    fluidType: '生食',
    volume: 250,
    concentration: 5.2,
  },
}

export default function ReservationDetail() {
  const { id } = useParams()
  const reservation = reservationData[id as keyof typeof reservationData] || reservationData['res-001']

  const getStatusClass = (status: string) => {
    switch (status) {
      case '完了': return 'success'
      case '処理中': return 'info'
      case '受付済': return 'info'
      case '保留中': return 'warning'
      default: return 'neutral'
    }
  }

  return (
    <>
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          <Link to="/reservations" className="aip-button aip-button--icon">
            <span className="material-symbols-outlined">arrow_back</span>
          </Link>
          <h1 className="aip-main__header-title">移植予約詳細</h1>
          <div className="aip-main__header-buttons">
            <button className="aip-button aip-button--outline">
              <span className="material-symbols-outlined">edit</span>
              編集
            </button>
          </div>
        </div>
      </header>

      <div className="aip-main__content">
        <div className="detail-container">
          {/* 基本情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">予約情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">ステータス</label>
                <span className={`aip-badge aip-badge--${getStatusClass(reservation.orderStatus)}`}>
                  {reservation.orderStatus}
                </span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">予約日時</label>
                <span className="detail-field__value">
                  {reservation.scheduledDate} {reservation.scheduledTime}
                </span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">時間枠</label>
                <span className="detail-field__value">{reservation.timeSlot}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">移植回数</label>
                <span className="detail-field__value">{reservation.transplantCount}回目</span>
              </div>
            </div>
          </section>

          {/* 患者情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">患者情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">研究会ID</label>
                <Link to={`/patients/${reservation.patientId}`} className="detail-field__value--link">
                  {reservation.researchId}
                </Link>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">患者ID</label>
                <span className="detail-field__value">{reservation.patientId}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">氏名（子音）</label>
                <span className="detail-field__value">{reservation.patientName}</span>
              </div>
            </div>
          </section>

          {/* 担当医情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">担当医</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">主治医</label>
                <span className="detail-field__value--link">{reservation.primaryDoctor}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">移植担当医</label>
                <span className="detail-field__value--link">{reservation.transplantDoctor}</span>
              </div>
            </div>
          </section>

          {/* 菌液情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">菌液情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">菌株Type</label>
                <span className="detail-field__value">{reservation.bacteriaType}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">処方内容</label>
                <span className="detail-field__value">{reservation.fluidType}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">容量</label>
                <span className="detail-field__value">{reservation.volume} ml</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">濃度</label>
                <span className="detail-field__value">{reservation.concentration}%</span>
              </div>
            </div>
          </section>

          {/* 受付・発送情報 */}
          <section className="detail-section">
            <h2 className="detail-section__title">受付・発送情報</h2>
            <div className="detail-grid">
              <div className="detail-field">
                <label className="detail-field__label">受注受付日時</label>
                <span className="detail-field__value">{reservation.orderDate}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">菌液発送日</label>
                <span className="detail-field__value">{reservation.fluidShippingDate || '未発送'}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">菌液到着</label>
                <span className="detail-field__value">{reservation.fluidArrival || '未確認'}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">ヤマト伝票番号</label>
                <span className="detail-field__value">{reservation.trackingNumber || '-'}</span>
              </div>
            </div>
          </section>

          {/* ドナー指定・備考 */}
          <section className="detail-section">
            <h2 className="detail-section__title">その他</h2>
            <div className="detail-grid">
              <div className="detail-field detail-field--full">
                <label className="detail-field__label">ドナー指定</label>
                <span className="detail-field__value">{reservation.donorDesignation || 'なし'}</span>
              </div>
              <div className="detail-field detail-field--full">
                <label className="detail-field__label">備考</label>
                <span className="detail-field__value">{reservation.notes || '-'}</span>
              </div>
              <div className="detail-field">
                <label className="detail-field__label">作成者</label>
                <span className="detail-field__value">{reservation.createdBy}</span>
              </div>
            </div>
          </section>
        </div>

        {/* アクションバー */}
        <div className="action-bar">
          <Link to="/reservations" className="aip-button aip-button--outline">
            戻る
          </Link>
          <div className="action-bar__right">
            <button className="aip-button aip-button--outline aip-button--alert">
              <span className="material-symbols-outlined">delete</span>
              削除
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .detail-container {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-lg);
        }

        .detail-section {
          background-color: var(--background-primary);
          padding: var(--spacing-lg);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .detail-section__title {
          font-size: 1rem;
          font-weight: 600;
          margin-bottom: var(--spacing-md);
          padding-bottom: var(--spacing-sm);
          border-bottom: 1px solid var(--border-color);
        }

        .detail-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: var(--spacing-md);
        }

        .detail-field {
          display: flex;
          flex-direction: column;
          gap: var(--spacing-xs);
        }

        .detail-field--full {
          grid-column: 1 / -1;
        }

        .detail-field__label {
          font-size: 0.75rem;
          color: var(--text-secondary);
        }

        .detail-field__value {
          font-size: 0.875rem;
          color: var(--text-primary);
        }

        .detail-field__value--link {
          font-size: 0.875rem;
          color: var(--color-blue600);
          cursor: pointer;
        }

        .detail-field__value--link:hover {
          text-decoration: underline;
        }

        .aip-badge {
          display: inline-block;
          padding: 4px 12px;
          font-size: 0.75rem;
          font-weight: 500;
          border-radius: var(--border-radius-sm);
        }

        .aip-badge--success {
          background-color: var(--color-success-light);
          color: var(--color-success);
        }

        .aip-badge--info {
          background-color: var(--color-blue100);
          color: var(--color-blue700);
        }

        .aip-badge--warning {
          background-color: var(--color-focus-light);
          color: #8b6914;
        }

        .aip-badge--neutral {
          background-color: var(--color-solid-gray100);
          color: var(--color-solid-gray700);
        }

        .action-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: var(--spacing-lg);
          padding: var(--spacing-md);
          background-color: var(--background-primary);
          border-radius: var(--border-radius-lg);
          box-shadow: var(--shadow-sm);
        }

        .action-bar__right {
          display: flex;
          gap: var(--spacing-sm);
        }

        .aip-button--alert {
          color: var(--color-alert);
          border-color: var(--color-alert);
        }

        .aip-button--alert:hover {
          background-color: var(--color-alert-light);
        }
      `}</style>
    </>
  )
}
